import React, { useState } from 'react'
import { TextField, Button, Typography, Box, Alert } from '@mui/material'
import { AxiosWithAuth } from '../../Utilities/authenticationService'
import PageWithTitleLayout from '../Layout/PageWithTitleLayout'
import SubmitSvg from '../SubmitShift/SubmitSvg'
import { isMobile } from '../../Utilities/isMobile'
import { ThemeProvider } from '@mui/material/styles'
import { theme } from '../Layout/Layout'

const ForgotPassword = ({ history }) => {
    const [email, setEmail] = useState('')
    const [resetPassword, setResetPassword] = useState(false)
    const [error, setError] = useState(false)

    if (resetPassword) {
        return (
            <ThemeProvider theme={theme}>
                <div
                    style={{
                        height: 'calc(100vh - 56px)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        margin: '0 1rem'
                    }}
                >
                    <SubmitSvg />
                    <Typography variant="header1" sx={{ fontSize: '20px' }}>
                        パスワード再設定のリンクを <br />
                        送信しました。
                    </Typography>
                    <Button
                        onClick={() => {
                            setResetPassword(null)
                            history.push('/login')
                        }}
                        variant="contained"
                        color="paloBlue"
                        fullWidth
                        sx={{ mt: 'auto', mb: '2rem', width: isMobile() ? '95%' : '620px' }}
                    >
                        ログイン画面へ
                    </Button>
                </div>
            </ThemeProvider>
        )
    }

    return (
        <ThemeProvider theme={theme}>
            <PageWithTitleLayout title="パスワード再設定" titleOnly={true}>
                <Box className="input-box shrinkable" component="form" autoComplete="off">
                    <Typography
                        variant="subtitle2"
                        sx={{
                            height: '2rem',
                            marginBottom: '.5rem'
                        }}
                    >
                        ご利用中のメールアドレスを入力してください。パスワード再設定のURLをお送ります。
                    </Typography>
                    <TextField
                        sx={{ marginTop: '1rem' }}
                        label="メールアドレス (Email address) "
                        type="email"
                        placeholder="例：pai@gmail.com"
                        helperText="半角英数字"
                        InputLabelProps={{ shrink: true }}
                        onChange={e => setEmail(e.target.value)}
                    />
                    {error && (
                        <Alert sx={{ mt: '1rem' }} severity="error">
                            送信に失敗しました。時間をおいて再度お試しください。
                        </Alert>
                    )}
                    <Button
                        variant="contained"
                        color="paloBlue"
                        sx={{ marginTop: '1rem', height: '42px' }}
                        disabled={!email}
                        onClick={() => {
                            setError(false)
                            AxiosWithAuth.post('/forgotPassword', { email })
                                .then(res => {
                                    res.status == 200 && setResetPassword(true)
                                })
                                .catch(() => {
                                    setError(true)
                                })
                        }}
                    >
                        送信する
                    </Button>
                </Box>
            </PageWithTitleLayout>
        </ThemeProvider>
    )
}
export default ForgotPassword
